import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:"",
    baseurl: process.env.VUE_APP_BASE_Res,
    currpage:0
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
